import { useField } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl';
import { HubAutocomplete } from './HubAutocomplete';
export function HubAutocompleteWithControl({
  name,
  label,
  ...other
}) {
  const {
    field: {
      onChange,
      value,
      ref
    },
    fieldState: {
      invalid: error
    },
    errorMessage
  } = useField({
    name
  });
  return <FormControl error={error} helperText={errorMessage} label={label}>
			<HubAutocomplete {...other} inputRef={ref} value={value ?? null} onChange={onChange} error={!!errorMessage} />
		</FormControl>;
}